import { PATIENT_CONSULTATION_STATUS } from "~/common/constants/consultation";
import { GroupOptions } from "~/common/utils";

export const ENGAGEMENT_TYPES = {
  active: "active",
  consultation: "consultation",
  inactive: "inactive",
} as const;

export const ENGAGEMENT_OPTIONS = Object.values(ENGAGEMENT_TYPES);

export const PATIENT_CONSULTATION_STATUS_BASIC_OPTIONS = Object.values(
  PATIENT_CONSULTATION_STATUS,
);

export const allFilters = [
  ...ENGAGEMENT_OPTIONS,
  ...PATIENT_CONSULTATION_STATUS_BASIC_OPTIONS,
];

export type EngagementTypes = keyof typeof ENGAGEMENT_TYPES;

export const engagementFilterOptions: GroupOptions[] = Object.values(
  ENGAGEMENT_TYPES,
).map((option) => ({
  value: option,
  label: option,
}));
